/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { awsBeanstalkDetector } from './AwsBeanstalkDetector';
export { awsEc2Detector } from './AwsEc2Detector';
export { awsEcsDetector } from './AwsEcsDetector';
export { awsEksDetector } from './AwsEksDetector';
export { awsLambdaDetector } from './AwsLambdaDetector';
